import { observable, runInAction } from 'mobx';

import config from '../config';

export class ResetPasswordStore {
    resetToken?: string;
    password?: string;
    @observable loading: boolean;

    async resetPassword() {
        this.loading = true;
        const res = await fetch(config.API_ENDPOINT + '/identity/update_password/', {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify({ reset_token: this.resetToken, new_password: this.password }),
        });

        const json = await res.json();
        runInAction(() => {
            this.loading = false;
        });

        if (!res.ok) {
            return Promise.reject(new Error(json.detail));
        }

        return Promise.resolve();
    }
}

export default new ResetPasswordStore;



// WEBPACK FOOTER //
// ./src/stores/ResetPasswordStore.ts